import axios from 'axios';
import tokenService from '../services/tokenService';

const API_URL = process.env.REACT_APP_BASE_URL+'/api/v1' || 'http://localhost:5000/api/v1';

// Create an axios instance with authentication
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Add interceptor to include token in requests
api.interceptors.request.use(
  (config) => {
    const token = tokenService.getToken();
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      console.log('API Request with token:', config.url);
    } else {
      console.warn('No auth token available for request:', config.url);
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging and error handling
api.interceptors.response.use(
  response => {
    console.log(`API Response ${response.config.url}:`, response.status);
    return response;
  },
  error => {
    // Debug auth errors
    if (error.response?.status === 401) {
      console.error('Authentication error:', error.response.config.url);
      tokenService.debugTokenStorage();
    }
    return Promise.reject(error);
  }
);

// Dashboard data
export const fetchDashboardData = async () => {
  try {
    tokenService.debugTokenStorage(); // Debug token before request
    console.log("Fetching dashboard data...");
    const response = await api.get('/dashboard/overview');
    return response.data;
  } catch (error) {
    console.error('Dashboard data fetch error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to fetch dashboard data');
  }
};

// TradingView access
export const fetchTradingViewAccess = async () => {
  try {
    console.log("Fetching TradingView access...");
    const response = await api.get('/dashboard/tradingview-access');
    return response.data;
  } catch (error) {
    console.error('TradingView access fetch error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to fetch TradingView access data');
  }
};

// Get Chargebee hosted page URL
export const getPaymentPortalUrl = async () => {
  try {
    const response = await api.get('/dashboard/payment-portal');
    return response.data;
  } catch (error) {
    console.error('Payment portal fetch error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to get payment portal URL');
  }
};

// Update user profile
export const updateUserProfile = async (profileData) => {
  try {
    const response = await api.patch('/dashboard/profile', profileData);
    return response.data;
  } catch (error) {
    console.error('Profile update error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to update profile');
  }
};
